import { useInfiniteQuery } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';
import { IGetMissingInventoryListPayload } from '../../../types';

/**
 * This is to track the Missing Inventory list from the backend.
 */
export const MISSING_INVENTORY_LIST_KEY = 'missing-inventory-list-query';

interface IGetMissingInventoryListQuery {
  payload: IGetMissingInventoryListPayload;
}

/**
 * This hook fetches the missing inventory list
 */
export const useMissingInventoryListQuery = ({
  payload,
}: IGetMissingInventoryListQuery) => {
  const { search, limit, inventoryTransactionId } = payload;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isPending,
    refetch,
  } = useInfiniteQuery({
    enabled: true,
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      MISSING_INVENTORY_LIST_KEY,
      search,
      limit,
      inventoryTransactionId,
    ],
    networkMode: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      INBOUND_API.fetchMissingInventoryList({ ...payload, page: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * limit;

      return currentCount < lastPage.total ? nextPage : undefined;
    },
  });

  return {
    fetchNextPage,
    hasNextPage,
    missingInventory: data,
    missingInventoryError: error,
    isError,
    isPending,
    refetchMissingInventory: refetch,
  };
};
